const baseUrl = 'test/';

export default {
  chatMessagesPath: uid => `${baseUrl}messages/${uid}`,
  chatMessagePath: (chatUid, messageUid) => `${baseUrl}messages/${chatUid}/${messageUid}`,
  chatsPath: id => `${baseUrl}users/${id}/chats`,
  messagesPath: uid => `${baseUrl}messages/${uid}`,
  chatUnreadCountPath: (userId, chatUid) => `${baseUrl}users/${userId}/chats/${chatUid}/unreadCount`,
  latestMessagePath: (userId, chatUid) => `${baseUrl}users/${userId}/chats/${chatUid}/latestMessage`,
  userOnlineStatusPath: userId => `${baseUrl}userStatuses/${userId}/isOnline`,
  usersOnlineStatusesPath: () => `${baseUrl}userStatuses`,
  chatFavoritePath: (userId, chatUid) => `${baseUrl}users/${userId}/chats/${chatUid}/isFavorite`,
  chatHiddenPath: (userId, chatUid) => `${baseUrl}users/${userId}/chats/${chatUid}/isHidden`,
  conversationDaysPath: (userId, chatUid, messageId) =>
    `${baseUrl}users/${userId}/chats/${chatUid}/conversationDays/${messageId}`,
  chatOrderChildPath: () => 'latestMessage/createdAt',
};



// WEBPACK FOOTER //
// ./src/routes/firebaseRoutes.js